import {LanguageCard} from "./LanguageCard";

export default LanguageCard;